import { getRequest, postRequest } from '@/api/requests'
import { PaginationListData, ResponseData } from '@/api/types/serviceTypes'
import { TestResponse } from '@/contexts/TestResponseContext'
import { ResultPreview, TestResultDetails } from './types/resultsTypes'
import { TestDetailsResponse, TestPage, TestParameterPage } from './types/testTypes'

interface IdGetter {
  id: string
}

export const getTestsService = async (
  params: TestParameterPage
): Promise<ResponseData<TestPage>> => {
  const response = await getRequest<TestPage>('/v1/tests', { ...params })
  return response
}

export const getTestDetailsService = async (
  id: string
): Promise<ResponseData<TestDetailsResponse>> => {
  const response = await getRequest<TestDetailsResponse>(`/v1/tests/${id}`, {})
  return response
}

export const evalutateTestService = async (body: TestResponse) => {
  const response = await postRequest<IdGetter>('/v1/tests/evaluate', { ...body })
  return response
}

export const getTestResultByIdService = async (id: string) => {
  const response = await getRequest<TestResultDetails>(`/v1/test-results/${id}`, {})
  return response
}

export const getTestResultsService = async (params: { page: number; pageSize: number }) => {
  const response = await getRequest<PaginationListData<ResultPreview>>(
    '/v1/test-results',
    { ...params }
  )
  return response
}
